<template>
  <!-- left main -->
  <div class="block-wrap d-flex my-4 flex-wrap align-items-center" >

    <div class="sp-avatar-box">
      <span class="ui-avatar size-120">
        <img :src="onshow_user.imageURL || '/static/pic/default_pic/default_avatar.jpg'">
      </span>
    </div>

    <div class="sp-username-box">
      <h2 v-if="onshow_user.username" class="mb-0">
        {{onshow_user.username}}
      </h2>
      <h2 v-else class="mb-0">
        {{onshow_user.address | shortAddress}}
      </h2>
    </div>
    <!-- <div class="">
      <br>
      <span class="small">
        {{onshow_user.bio}}
      </span>
    </div> -->

    <div class="sp-btn-box d-flex">
      <button class="mx-3 btn btn-outline-primary btn-sm gray pr-3 d-flex align-items-center" @click="shareGallery()">
        <i class="ui-icon-share mr-2"></i>
        <span>
          {{lg('',{
            en: 'SHARE',
            zh: '分享',
          })}}
        </span>
      </button>

      <router-link 
        v-if="onshow_user.address === $store.state.web3.account"
        :to="{name: 'profile'}"
        class="mx-3 btn btn-outline-primary btn-sm gray pr-3 d-flex align-items-center"
        >
        <i class="fas fa-cog mx-2 op8"></i>
        <span>
          {{lg('',{
            en: 'SETTINGS',
            zh: '设置',
          })}}
        </span>
      </router-link>
    </div>
  </div>
</template>

<script>
import bus from '@/bus.js'
import {mapActions} from 'vuex'

export default {
  name: 'blockProfile',
  components: {},
  props: [
    // cfg : {auto_call_login: true,}
    'cfg',
  ],
  data() {
    return {
      // for edit btn
      status_poppad_userinfo: false,

      sync_avatar: {
        img_url: '',
        status_uploading: false,
        status_upload_percent: 0,
      },

      form: {
        username: '',
        email: '',
        bio: '',
        imageURL: '',
      },

      // address_custom
      user_address_custom: {},

      // 
      onshow_user: {}
    }
  },
  computed: {

  },
  watch: {
    '$store.state.web3.account'(val){
      if(val){
        this.run()
      }
    },
    'status_poppad_userinfo'(val){
      if(val){
        this.fillForm()
      }
    },
    'sync_avatar.img_url'(val){
      this.form.imageURL = val
    },

    user_address_custom(){
      this.calcOnshowUser()
    },
    '$store.state.user.local_user': {
      deep: true,
      handler(val){
        this.calcOnshowUser()
      }
    },
  },
  methods: {

    ...mapActions([
      'accountSign',
    ]),

    shareGallery(){
      let v = this
      let u_name = v.onshow_user.username || v.$store.state.user.local_user.username || v.$store.state.user.local_user.address
      let href = window.location.href
      bus.appvue.showPopupShareItem({
        share_link: `${href}${href.indexOf('?')>0?'&':'?'}addrfrom=${v.$store.state.web3.account}`,
        share_title: `Check out this awesome NFT from JuggerWOLD! ${u_name}'s profile. #BSC #JGNDeFi #Collectible #NFT #JGNNFT $JGN `,
        pad_title: v.lg('share_this_gallery')
      })
    },

    async save(){
      let v = this
      let address_my = v.$store.state.web3.account
      let sig = await v.accountSign(address_my)


      let form = {
        address: address_my,
        sign: sig,
        username: v.form.username,
        email: v.form.email,
        bio: v.form.bio,
        imageURL: v.form.imageURL,
      }

      v.api('user_update',form,{
        vue: v,
        done_run_function: ['getUserInfo'],
      }).then(function(){
        v.status_poppad_userinfo = false
      })
    },

    fillForm(){
      let v = this

      v.form.username = v.onshow_user.username
      v.form.email = v.onshow_user.email
      v.form.bio = v.onshow_user.bio
      v.form.imageURL = v.onshow_user.imageURL
    },

    async getUserInfo(){
      let v = this
      let address_my = v.$store.state.web3.account
      let address_user = v.$store.state.user.local_user.address

      let res
      
      if(v.cfg.address_custom){
        res = await v.api('user_info',{address: v.cfg.address_custom})
        
        if(res && res.data){
          v.user_address_custom = res.data
        }

        // empty profile user
        if(res && res.data && !res.data.id){
          console.log('gagag o')
          v.user_address_custom = {
            id: 'none',
            address: v.$route.query.addrfrom,
          }
        }
      }
      else{
        res = await v.uniCheckUserLogin()
        if(!res){
          // call signin pad
          if((v.cfg && v.cfg.auto_call_login) && address_my && !address_user){
            bus.headervue.mark_sign_ui_call += 1
          }
        }
      }

    },

    calcOnshowUser(){
      let v = this
      let mark = null
      
      if(v.cfg.address_custom && (v.$store.state.user.local_user.address != v.cfg.address_custom)){
        mark = v.user_address_custom
      }else{
        mark = JSON.parse(JSON.stringify(v.$store.state.user.local_user))
      }

      if(v.$parent.gallery_cfg){
        v.$parent.gallery_cfg.onshow_user = mark
      }
      v.onshow_user = mark
    },

    run(){
      let v = this
      this.calcOnshowUser()
      this.getUserInfo()
    },
  },
  created() {
    this.run()
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .block-wrap{
    @media(min-width: 788px){

      &>div{
        margin-right: 30px;
      }
    }
    @media(max-width: 788px){
      text-align: center;

      &>div{
        width: 100%;
        margin: 10px 0;
      }
    }
  }
</style>